import styled from 'styled-components';
import { ReactComponent as RawEyeSVG } from '../../../../assets/icons/eye.svg';

export const IconEye = styled(RawEyeSVG)`
  .a {
    fill: rgba(255,255,255,0);
  }
  
  .b {
    opacity: 0.302;
  }
`;
